module.exports = __webpack_public_path__ + "static/img/ico_little_code.a1ba8ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/application/ico_little_code.png
// module id = xmTq
// module chunks = 0